import * as React from "react";
import PageHeaderView from "../../body/PageHeaderView";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import PageContentView from "../../body/PageContentView";
import Task from "../../../model/task/Task";
import {none, option, Option} from "ts-option";
import Loading from "../../ui/loading/Loading";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import TasksTable from "./table/TasksTable";
import CreateTaskModal from "./modal/CreateTaskModal";
import EditTaskModal from "./modal/EditTaskModal";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import {Dispatch} from "redux";
import {fetchActivityTemplates, fetchJobActivityTemplates} from "../../../store/action/survey/survey";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import Routes from "../../../navigation/route/Route";
import TaskUtils from "../../../utils/TaskUtils";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface ReduxProps {
	tasks: Option<Task[]>;
	activityTemplates: Option<DictionaryItem[]>;
	jobActivityTemplates: Option<DictionaryItem[]>;
}

interface IDispatchProps {
	fetchActivityTemplates: () => void
	fetchJobActivityTemplates: () => void
}

interface IState {
	/**
	 * User modal visibility flag
	 */
	userCreationModalVisible: boolean
	/**
	 * Edit user
	 */
	task: Option<Task>;
	/**
	 * Map taskId => Activity templates array
	 */
	templatesGroupedByTasks: Option<{ [key: string]: DictionaryItem[] }>
}


type Props = ReduxProps & IDispatchProps & RouteComponentProps<any>;

class TasksList extends React.Component<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {userCreationModalVisible: false, task: none, templatesGroupedByTasks: none};
		this.closeModal = this.closeModal.bind(this);
		this.openModal = this.openModal.bind(this);
		this.navigatesToActivityTemplate = this.navigatesToActivityTemplate.bind(this);
	}

	componentDidMount() {
		if (this.props.activityTemplates.isEmpty) {
			this.props.fetchActivityTemplates();
		}
		if (this.props.jobActivityTemplates.isEmpty) {
			this.props.fetchJobActivityTemplates();
		}
		this.fetchActivityTask();
	}

	componentWillReceiveProps(nextProps: ReduxProps) {
		this.fetchActivityTask()
	}

	fetchActivityTask() {
		if (this.props.activityTemplates.isDefined && this.props.jobActivityTemplates.isDefined &&
			this.state.templatesGroupedByTasks.isEmpty) {
			const activityTemplates = this.props.activityTemplates.getOrElse([]);
			const jobActivityTemplates = this.props.jobActivityTemplates.getOrElse([]);
			TaskUtils.getGroupedTasks(activityTemplates, jobActivityTemplates,
				(templatesGroupedByTasks) => this.setState({templatesGroupedByTasks}))
		}
	}

	render() {
		return (
			<div>
				<PageHeaderView header={"Tasks"}>
					<ButtonPrimary label={"Create Task"} onClick={this.openModal}/>
				</PageHeaderView>
				<PageContentView>
					<Loading isLoading={this.props.tasks.isEmpty}>
						<TasksTable tasks={this.props.tasks.getOrElse([])}
									onRowClick={(task) => {this.setState({task: option(task)})}}
									templatesGroupedByTasks={this.state.templatesGroupedByTasks}
									navigatesToActivityTemplate={this.navigatesToActivityTemplate}/>
					</Loading>
					{this.renderCreateUserModal()}
					{this.renderEditUserModal()}
				</PageContentView>
			</div>
		)
	}

	/**
	 * Render modal.
	 */
	renderCreateUserModal() {
		if (this.state.userCreationModalVisible) {
			return (
				<CreateTaskModal
					onSuccess={this.closeModal}
					onCancel={this.closeModal}/>
			);
		}
	}

	/**
	 * Render modal.
	 */
	renderEditUserModal() {
		if (this.state.task.isDefined) {
			return (
				<EditTaskModal
					task={this.state.task.get}
					onSuccess={() => this.setState({task: none})}
					onCancel={() => this.setState({task: none})}/>
			);
		}
	}

	/**
	 * Close modal with user creator.
	 */
	closeModal() {
		this.setState({userCreationModalVisible: false});
	}

	/**
	 * Open modal.
	 */
	openModal() {
		this.setState({userCreationModalVisible: true});
	}

	navigatesToActivityTemplate(activityTemplateId: string) {
		if (this.props.jobActivityTemplates.getOrElse([]).filter(jat => jat.id == activityTemplateId)[0]) {
			this.props.history.push(Routes.JobActivityTemplateTasks(activityTemplateId))
		}
		else {
			this.props.history.push(Routes.ActivityTemplateTasks(activityTemplateId));
		}
	}
}

function mapStateToProps(state: RootState) {
	return {
		tasks: state.task.tasks,
		activityTemplates: state.survey.activityTemplates,
		jobActivityTemplates: state.survey.jobActivityTemplates
	}
}


function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchActivityTemplates: () => dispatch(
			fetchActivityTemplates(() => {}, (error) => notifyBugsnagAndShowToast(error, "Fetch activity templates"))),
		fetchJobActivityTemplates: () => dispatch(
			fetchJobActivityTemplates(() => {}, (error) => notifyBugsnagAndShowToast(error, "Fetch job activity templates")))
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TasksList))